import { cn } from "@babackapp/customer-ui/lib/utils";
import { AnimatePresence, motion } from "motion/react";
import { useLocation, useOutlet } from "react-router-dom";
import { LineItemBar } from "./line-item-bar";
import { LineItemStepper } from "./line-item-stepper";
import { SummaryToolbar } from "./summary-toolbar";

export function LineItemLayout() {
  const { pathname } = useLocation();
  const parts = pathname.split("/");
  const group = parts[parts.length - 3];
  const step = parts[parts.length - 1];
  const outlet = useOutlet();

  return (
    <div className="w-full flex flex-col flex-1">
      <AnimatePresence mode="wait">
        {group === "line-item" && step !== "confirmation" && (
          <motion.div
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1, transition: { type: "spring" } }}
            exit={{ y: -50, opacity: 0 }}
            className={cn("absolute top-8 left-8 right-6")}
          >
            <LineItemStepper />
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence mode="popLayout">
        {!["line-item", "confirmation"].includes(step) ? (
          <LineItemBar />
        ) : (
          <SummaryToolbar />
        )}
      </AnimatePresence>
      <AnimatePresence mode="wait" propagate>
        <motion.div key={pathname} className="h-full">
          {outlet}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
